export interface WebLoginUser {
  role?: string | null;
  roles?: unknown;
  accessMode?: string | null;
}

const ADMIN_ROLES = new Set(['admin', 'superadmin', 'super_admin']);

export function shouldBlockOperatorWebLogin(user: WebLoginUser | null | undefined): boolean {
  const role = typeof user?.role === 'string' ? user.role : '';
  const roles = Array.isArray(user?.roles) ? user.roles.map(String) : [];
  const effectiveRoles = new Set([role, ...roles].filter(Boolean));

  const isPortalExternal = user?.accessMode === 'portal_external';
  const isAdminLike = [...effectiveRoles].some((candidate) => ADMIN_ROLES.has(candidate));
  const isOperator = effectiveRoles.has('operator');

  return isOperator && !isAdminLike && !isPortalExternal;
}
